import moment from 'moment';
import tourProductForRenderAdapter from '@/js/common/Service/tourProductForRenderAdapter';
import { formatNumber, wordEnding } from '@ve/services/textModifiers';

export default function generateObjectToutProductFromRender(parent = {}) {
    const { model } = parent;

    const tourProductRenderAdapterData = tourProductForRenderAdapter(parent);
    const {
        tour,
        railwayTour,
        hotelOffer,
        product,
        nights,
    } = tourProductRenderAdapterData;
    const routes = (tour || railwayTour)?.get('routes');
    const route = routes && routes[0] ? routes[0] : null;
    const there = route ? route.there : null;
    const back = route ? route.back : null;

    const checkInDateRangeFrom = product.get('checkInDateRange').get('from');
    const checkInDateRangeTo = product.get('checkInDateRange').get('to');
    const datetimeForwardCalculatedWithRoutes = (route && there?.legs?.[0].departureDate) ? there.legs[0].departureDate : null;
    const datetimeBackwardCalculatedWithRoutes = (route && back?.legs?.[0].departureDate) ? back.legs[0].departureDate : null;

    const datetimeForwardForRender = datetimeForwardCalculatedWithRoutes ?? checkInDateRangeFrom;
    const datetimeBackwardForRender = datetimeBackwardCalculatedWithRoutes ?? checkInDateRangeTo;
    const datetimeForward = `${moment(datetimeForwardForRender).format('DD MMMM')}, ${moment(datetimeForwardForRender).format('ddd')}`;
    const datetimeBackward = `${moment(datetimeBackwardForRender).format('DD MMMM')}, ${moment(datetimeBackwardForRender).format('ddd')}`;

    let adults = null;
    let kids = null;
    let infants = null;
    if (product.get('touristGroup')) {
        adults = product.get('touristGroup').adults;
        kids = product.get('touristGroup').kids;
        infants = product.get('touristGroup').infants;
    }

    if (adults > 0) {
        adults = `${adults} взросл${adults.wordEnding('ый;ых;ых')}`;
        if (kids > 0) {
            kids = ` и ${kids + infants} ${(kids + infants).wordEnding('ребенок;детей;детей')}`;
        } else if (infants > 0) {
            kids = ` и ${infants} ${infants.wordEnding('младенец;младенца;младенцев')}`;
        } else {
            kids = '';
        }
    }

    const roomName = product.get('room').name
        ? ` класса ${product.get('room').name}`
        : '';
    const roomLabel = `Номер для ${adults + kids} на ${nights} ноч${nights.wordEnding('ь;и;ей')}${roomName}. Питание: ${product.get('meal')?.get('name')}`;

    return {
        ...tourProductRenderAdapterData,
        id: model.get('id'),
        datetimeForward,
        datetimeBackward,
        adults,
        kids,
        infants,
        checkInDateRangeFrom,
        flightType: product.get('flightType') ?? null,
        roomLabel,
        mealName: product.get('meal')?.get('name')?.toLowerCase(),
        cashbackHotelValue: hotelOffer?.get('paymentCashBackHotel'),
        cashbackTourValue: tour?.get('paymentCashBackTour'),
        cashbackRailwayTourValue: railwayTour?.get('paymentCashBackRailwayTour'),
        freeCancellationHotelOffer: model.get('freeCancellationHotelOffer'),
        formatNumber,
        wordEnding,
    };
}